<template>
  <div class="container">
    <div class="card-body text-center">
      <div v-if="loading">
        <h3><i class="fa-solid fa-spinner fa-spin"></i> Yoxlanılır...</h3>
      </div>
      <div v-else-if="success">
        <h3><i class="fa-solid fa-check text-success"></i> Uğurlu giriş! Yönləndirilir...</h3>
      </div>
      <div v-else>
        <h3><i class="fa-solid fa-times text-danger"></i> {{ error }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
import { reportApi } from '../services/api'

export default {
  name: 'SessionView',
  props: {
    token: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: true,
      success: false,
      error: ''
    }
  },
  async mounted() {
    // 1. LOGOUT
    if (this.token === 'LOGOUT') {
      this.loading = false
      this.error = 'Uğurlu çıxış'
      localStorage.removeItem('report_token')
      // Web app-dakı kimi: URL-də LOGOUT görünür, redirect yoxdur
      return
    }

    // 2. Token var — yoxla
    if (this.token && this.token !== 'invalid') {
      await this.validateToken()
      return
    }

    // 3. Token yoxdur — artıq localStorage-da token varmı?
    const saved = localStorage.getItem('report_token')
    if (saved) {
      this.success = true
      this.loading = false
      setTimeout(() => this.$router.replace('/'), 500)
      return
    }

    // 4. Heç bir token yoxdur
    this.loading = false
    this.error = 'Sessiya tapılmadı'
  },
  methods: {
    async validateToken() {
      this.loading = true
      try {
        const res = await reportApi.getClientByToken(this.token, true)
        if (res.data?.IsSuccess) {
          // Token keçərlidir — localStorage-a yaz
          localStorage.setItem('report_token', this.token)
          this.loading = false
          this.success = true
          // Web app-dakı kimi: 500ms sonra ana səhifəyə yönləndir, URL itir
          setTimeout(() => this.$router.replace('/'), 500)
        } else {
          throw new Error(res.data?.Error || 'İstifadəçi tapılmadı')
        }
      } catch (err) {
        this.loading = false
        this.success = false
        if (err.response?.status === 404 || err.response?.status === 401) {
          this.error = 'İstifadəçi tapılmadı'
        } else if (err.message) {
          this.error = err.message
        } else {
          this.error = 'Server/şəbəkə xətası'
        }
      }
    }
  }
}
</script>
